import ShareListingModal from './ShareListingModal.component';

export default ShareListingModal;